'use client';

import React from 'react';
import { Box } from '@chakra-ui/react';
import { signupStyles } from '@/components/features/registration/signup-templates/signup.styles';
import { usePathname } from 'next/navigation';

const RegistrationLayout = ({ children }: { children: React.ReactNode }) => {
   const pathname = usePathname();

   const isKycPage = pathname?.includes('kyc');

   return (
      <Box
         css={signupStyles.signup_box}
         overflow={isKycPage ? 'visible' : 'auto'}
         py={isKycPage ? '0' : { base: 16, md: 24 }}
         px={isKycPage ? '0' : { base: 6, md: 10 }}
      >
         {children}
      </Box>
   );
};

export default RegistrationLayout;
